import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IConsultationsListState } from './interfaces';
import { getRequest } from 'api/requests';

// Загрузка списка логов
export const fetchConsultations = createAsyncThunk(
  'consultationsList/fetchConsultations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest('consultation', {}, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const ConsultationsListSelector = (
  state: RootState,
): IConsultationsListState => state.consultationsList;

export const ConsultationsListLoadingSelector = createSelector(
  ConsultationsListSelector,
  ({ isLoading }) => isLoading,
);

export const ConsultationsListItemsSelector = createSelector(
  ConsultationsListSelector,
  ({ items }) => items,
);

const initialState: IConsultationsListState = {
  isLoading: false,
  items: [],
};

const consultationsListSlice = createSlice({
  name: 'consultationsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultations.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(fetchConsultations.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchConsultations.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload,
      }));
  },
});

export default consultationsListSlice.reducer;
